const stripTrailingSlash = (value) => `${value || ''}`.replace(/\/+$/, '');
const withTrailingSlash = (value = '') => {
	const stripped = stripTrailingSlash(value);
	return stripped ? `${stripped}/` : '';
};

const serverRoot = stripTrailingSlash(process.env.VUE_APP_SERVER_PATH);
const apiBase = process.env.VUE_APP_API_URL || (serverRoot ? `${serverRoot}/api` : '/api');
const hiddenPriceValues = ['false', '0', 'no', 'off'];
const enabledValues = ['true', '1', 'yes', 'on'];

export const SHOW_PRICE_TOGGLE = enabledValues.includes(String(process.env.VUE_APP_SHOW_PRICE_TOGGLE || 'false').toLowerCase());
const storedPriceOverride = (() => {
	if (!SHOW_PRICE_TOGGLE || typeof window === 'undefined') return null;
	const value = window.localStorage.getItem('gixcore_show_prices_override');
	return value === 'true' ? true : value === 'false' ? false : null;
})();

export const apiDomain              = withTrailingSlash(apiBase);
export const SERVER_PATH            = apiDomain;
export const loginUrl               = apiDomain + 'users/auth/login';
export const oathLoginUrl           = apiDomain + 'oath/token';
export const GOOGLE_CLIENT_ID       = process.env.VUE_APP_GOOGLE_CLIENT_ID || '';
const envShowPrices                 = !hiddenPriceValues.includes(String(process.env.VUE_APP_SHOW_PRICES || 'true').toLowerCase());
export const SHOW_PRICES            = storedPriceOverride === null ? envShowPrices : storedPriceOverride;

// Cloudflare Turnstile site key for the login/register captcha.
// Defaults to Cloudflare's "always passes" test key so local dev works without setup;
// set VUE_APP_TURNSTILE_SITE_KEY to the real key in staging/production.
export const TURNSTILE_SITE_KEY     = process.env.VUE_APP_TURNSTILE_SITE_KEY || '1x00000000000000000000AA';

export const addItemUrl             = apiDomain + 'additem';

export const deleteItemUrl          = apiDomain + 'single';

export const AMAZON_TAG             = 'gixcore03-20';
export const AMAZON_LINK            = 'https://www.amazon.com/dp/';
export const AMAZON_REF             = '?th=1&linkCode=ll2&tag=' + AMAZON_TAG;

// Multi-item cart handoff for completed builds. Amazon's add-to-cart form takes
// repeated ASIN.N / Quantity.N pairs plus the Associates tag, so the whole parts
// list can be sent over in one click. See src/utils/amazonCart.js for the
// Associates policy notes behind the mode switch.
export const AMAZON_CART_LINK       = 'https://www.amazon.com/gp/aws/cart/add.html';

// 'bulk' sends every part in one cart URL. Set VUE_APP_AMAZON_CART_MODE=sequential
// to fall back to one cart link per part -- no code change needed if Amazon stops
// honouring the bulk form.
export const AMAZON_CART_MODE       = String(process.env.VUE_APP_AMAZON_CART_MODE || 'bulk').toLowerCase() === 'sequential'
	? 'sequential'
	: 'bulk';

export const sanitizeAmazonAsin = (value) => {
	const raw = `${value || ''}`.trim();
	const match = raw.match(/\/(?:dp|gp\/product)\/([A-Z0-9]{10})/i)
		|| raw.match(/[?&]asin=([A-Z0-9]{10})/i)
		|| raw.match(/^([A-Z0-9]{10})$/i);

	return match ? match[1].toUpperCase() : '';
};

export const amazonProductUrl = (asin) => {
	const cleanAsin = sanitizeAmazonAsin(asin);
	if (!cleanAsin) {
		return null;
	}

	return AMAZON_LINK + encodeURIComponent(cleanAsin) + AMAZON_REF;
};

export default apiDomain;
